module.exports = __webpack_public_path__ + "static/media/img-ovato-symbol-new.10bdc61f.pdf";